module.exports = __webpack_public_path__ + "static/img/__9364.86c00d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__9364.jpg
// module id = IrOx
// module chunks = 0